"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserRegionConfig = void 0;
var _userActions = require("./userActions");
var setUserRegionConfig = exports.setUserRegionConfig = function setUserRegionConfig(language) {
  return function (dispatch, getState) {
    var _getState = getState(),
      userInfo = _getState.user.userInfo;
    var UserId = userInfo.UserId,
      UserName = userInfo.UserName;
    var configValue = [{
      Key: 'Language',
      Value: language
    }];
    dispatch((0, _userActions.setUserConfig)(UserId, UserName, configValue));
  };
};